import React, { useContext, useState } from "react";
import "./index.scss";
import ModalInput from "../../ui-kit/modal";
import { Link, useParams } from "react-router-dom";
import { Trans } from "@lingui/react/macro";

export const PaywallContext = React.createContext({});

export const PaywallProvider = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [renderItems, setRenderItems] = useState({});

  const { projectID } = useParams();

  return (
    <PaywallContext.Provider
      value={{
        isVisible,
        setIsVisible,
        renderItems,
        setRenderItems,
      }}
    >
      <ModalInput
        isOpened={isVisible}
        onOutsideClick={() => {
          setIsVisible(false);
        }}
        overlayFrameClassName={"w-[500px] max-w-[80%]"}
      >
        <div className="p-8 text-center text-grigora-base">
          <img
            src="/images/access-denied.svg"
            alt="Limit"
            className="mb-5 w-[200px] mx-auto"
          />
          <h1 className="modal-heading mb-3">
            {renderItems?.title ?? (
              <Trans id="paywall.title">{"You have reached limit!"}</Trans>
            )}
          </h1>
          <p className="mb-5">
            {renderItems?.description ?? (
              <Trans id="paywall.description">
                {"Please upgrade your plan to continue."}
              </Trans>
            )}
          </p>
          <div className="text-center">
            <Link
              to={renderItems?.link ?? `/billing`}
              onClick={(e) => {
                setIsVisible(false);
              }}
              className="grigora-action-btn"
            >
              <Trans id="billing.upgradeCta">{"Upgrade"}</Trans>
            </Link>
          </div>
        </div>
      </ModalInput>
      {children}
    </PaywallContext.Provider>
  );
};
